import type { LeaderboardRow } from "./leaderboardTableUtils";

export const SAMPLE_LEADERBOARD_ROWS: LeaderboardRow[] = [
  {
    sponsor_id: "sample-1",
    sponsor_name: "Sarah Mitchell",
    theater: "Americas",
    region: "North America",
    rank: 1,
    composite: 4.72,
    p1: 4.8,
    p2: 4.6,
    tier: "Champion",
    delta: 0.18,
    gap: "Aligned-High",
  },
  {
    sponsor_id: "sample-2",
    sponsor_name: "James Okafor",
    theater: "EMEA",
    region: "UK",
    rank: 2,
    composite: 4.55,
    p1: 4.6,
    p2: 4.5,
    tier: "Champion",
    delta: 0.12,
    gap: "Aligned-High",
  },
  {
    sponsor_id: "sample-3",
    sponsor_name: "Priya Sharma",
    theater: "APAC",
    region: "ASEAN",
    rank: 3,
    composite: 4.31,
    p1: 4.2,
    p2: 4.4,
    tier: "Champion",
    delta: -0.08,
    gap: "Under-report",
  },
  {
    sponsor_id: "sample-4",
    sponsor_name: "Marcus Chen",
    theater: "Americas",
    region: "West",
    rank: 4,
    composite: 3.87,
    p1: 4.0,
    p2: 3.7,
    tier: "Active",
    delta: 0.05,
    gap: "Over-claim",
  },
  {
    sponsor_id: "sample-5",
    sponsor_name: "Elena Rodriguez",
    theater: "EMEA",
    region: "DACH",
    rank: 5,
    composite: 3.64,
    p1: 3.8,
    p2: 3.5,
    tier: "Active",
    delta: -0.21,
    gap: "Aligned-High",
  },
  {
    sponsor_id: "sample-6",
    sponsor_name: "David Park",
    theater: "APAC",
    region: "ANZ",
    rank: 6,
    composite: 2.93,
    p1: 3.1,
    p2: 2.7,
    tier: "Developing",
    delta: 0.31,
    gap: "Over-claim",
  },
  {
    sponsor_id: "sample-7",
    sponsor_name: "Anna Thompson",
    theater: "Americas",
    region: "LATAM",
    rank: 7,
    composite: 2.41,
    p1: 2.3,
    p2: 2.5,
    tier: "Developing",
    delta: -0.15,
    gap: "Under-report",
  },
  {
    sponsor_id: "sample-8",
    sponsor_name: "Raj Patel",
    theater: "EMEA",
    region: "MENA",
    rank: 8,
    composite: 1.85,
    p1: 1.9,
    p2: 1.8,
    tier: "At-Risk",
    delta: -0.42,
    gap: "At-risk",
  },
];

export const SAMPLE_APPROVAL_REVIEW_NOTES =
  "Please review Q3 rankings before publishing.";
